// extracted by mini-css-extract-plugin
module.exports = {"scrolledWindow":"profile-orders_scrolledWindow__2UYSI","link":"profile-orders_link__TxlSb"};